import { useContext } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import Loader from '../components/Loader';
import { safeReturnPath } from '../auth/returnPath';
import './AuthStatusPage.scss';

export default function EntraCallback() {
  const {
    authError,
    authToken,
    isInitialized,
    lastAuthResult,
    signInWithAnotherAccount,
    user,
  } = useContext(UserContext);

  if (authError) {
    // E.g. the email already has a password account (no automatic linking), or
    // the account isn't allowed in the current rollout mode.
    return (
      <div className="auth-status-page" dir="rtl">
        <h1>ההתחברות לא הושלמה</h1>
        <p role="alert">{authError}</p>
        {/* Signs out of Microsoft and returns to /signin, to try another account
            (the same invitation, the same return path). */}
        <button type="button" className="auth-status-primary" onClick={() => signInWithAnotherAccount()}>
          התחברות עם חשבון אחר
        </button>
        <Link to="/login" className="auth-status-link">כניסה עם סיסמה</Link>
      </div>
    );
  }

  if (!authToken || !isInitialized || !lastAuthResult) {
    return <Loader isLoading={true} />;
  }

  if (lastAuthResult.isNew || ['profile', 'workplace'].includes(user?.entraOnboarding?.status)) {
    return <Navigate replace to="/onboarding/register" />;
  }

  // Return where the user was going: the page that sent them to /login or
  // /signin, or the page that asked for two-step verification. Same-site paths
  // only, never a sign-in page (auth/returnPath).
  const returnTo = safeReturnPath(lastAuthResult.returnTo);
  if (returnTo) {
    return <Navigate replace to={returnTo} />;
  }

  return <Navigate replace to="/homepage" />;
}
